<template>
  <div class="community">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <ContentHeader :name="'Search results for: ' + $route.params.search"></ContentHeader>
        <!-- Communities -->
        <div v-if="communities.length > 0" class="mb-3">
          <h4>Communities</h4>
          <router-link v-for="community in communities" v-bind:key="community.id" :to="'/communities/community/' + community.slug">
            <div class="community card mb-3">
              <div class="featuredImg">
                <img v-if="community._embedded['wp:featuredmedia']"
                  :src="community._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
                  :alt="community._embedded['wp:featuredmedia'][0].alt_text"
                  :title="community._embedded['wp:featuredmedia'][0].title.rendered"
                >
              </div>
              <div class="card-body">
                <h5>{{community.title.rendered}}</h5>
                <div v-html="community.excerpt.rendered"></div>
              </div>
            </div>
          </router-link>
        </div>
        <!-- Ideas -->
        <div v-if="ideas.length > 0" class="mb-3">
          <h4>Ideas</h4>
          <Ideas :ideas="ideas"></Ideas>
        </div>
        <!-- Idea challenges -->
        <div v-if="ideasChallenges.length > 0" class="mb-3">
          <h4>Idea challenges</h4>
          <router-link v-for="challenge in ideasChallenges" v-bind:key="challenge.id" :to="'/idea-challenges/idea-challenge/' + challenge.slug">
            <div class="idea-challenge card mb-3">
              <div v-if="challenge._embedded['wp:featuredmedia'] !== undefined" class="featuredImg">
                <img v-if="challenge._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
                  :src="challenge._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
                  :alt="challenge._embedded['wp:featuredmedia'][0].alt_text"
                  :title="challenge._embedded['wp:featuredmedia'][0].title.rendered"
                >
              </div>
              <div class="card-body">
                <h5>{{challenge.title.rendered}}</h5>
                <div v-html="challenge.excerpt.rendered" class="mt-3"></div>
              </div>
            </div>
          </router-link>
        </div>
        <div v-if="pages.length > 0" class="mb-3">
          <h4>Pages</h4>
          <router-link :to="'/page/' + page.slug" v-for="page in pages" v-bind:key="page.id">
            <div class="page card mb-3">
              <div v-if="page._embedded['wp:featuredmedia'] !== undefined" class="featuredImg">
                <img v-if="page._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
                  :src="page._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
                  :alt="page._embedded['wp:featuredmedia'][0].alt_text"
                  :title="page._embedded['wp:featuredmedia'][0].title.rendered"
                >
              </div>
              <div class="card-body">
                <h5>{{page.title.rendered}}</h5>
                <div v-html="page.excerpt.rendered" class="mt-3"></div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import ContentHeader from '@/components/ContentHeader'
import Ideas from '@/components/Ideas'
import PreContentHeader from '@/components/PreContentHeader'
export default {
  components: {
    PreContentHeader,
    ContentHeader,
    Ideas
  },
  data () {
    return {
      contentReady: true,
      contentLoadError: '',
      communities: [],
      ideas: [],
      ideasChallenges: [],
      pages: []
    }
  },
  methods: {
    searchCommunities: function () {
      WordpressRestAPI.getViewContent('communities?search=' + this.$route.params.search.replace(/ /g, '+') + '&_embed&per_page=100')
        .then(response => {
          this.communities = response.data
          this.contentReady = true
        })
        .catch(e => {
          this.contentLoadError = 'Oops! We had a problem with searching for communities. Please try again later.'
          console.error(e)
          this.contentReady = true
        })
    },
    searchIdeas: function () {
      WordpressRestAPI.getViewContent('idea?search=' + this.$route.params.search.replace(/ /g, '+') + '&_embed&per_page=100')
        .then(response => {
          this.ideas = response.data
          this.contentReady = true
        })
        .catch(e => {
          this.contentLoadError = 'Oops! We had a problem with searching for ideas. Please try again later.'
          console.error(e)
          this.contentReady = true
        })
    },
    searchIdeaChallenges: function () {
      WordpressRestAPI.getViewContent('idea_challenge?search=' + this.$route.params.search.replace(/ /g, '+') + '&_embed&per_page=100')
        .then(response => {
          this.ideasChallenges = response.data
          this.contentReady = true
        })
        .catch(e => {
          this.contentLoadError = 'Oops! We had a problem with searching for idea challenges. Please try again later.'
          console.error(e)
          this.contentReady = true
        })
    },
    searchPages: function () {
      WordpressRestAPI.getViewContent('pages?search=' + this.$route.params.search.replace(/ /g, '+') + '&_embed&per_page=100')
        .then(response => {
          this.pages = response.data
          this.contentReady = true
        })
        .catch(e => {
          this.contentLoadError = 'Oops! We had a problem with searching for pages. Please try again later.'
          console.error(e)
          this.contentReady = true
        })
    },
    searchAll: function () {
      this.searchCommunities()
      this.searchIdeas()
      this.searchIdeaChallenges()
      this.searchPages()
    }
  },
  created () {
    document.title = this.$route.name + ' - ThinkTank'
    this.searchAll()
  },
  watch: {
    '$route' (to, from) {
      document.title = this.$route.name + ' - ThinkTank'
      this.searchAll()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/routes/Search.vue